import React, {Component} from 'react';
import ImageAPI from "../classes/ImageAPI";
import Favourite from "./Favourite";
import VenueImage from "./VenueImage";
import { Trans } from 'react-i18next';

class SearchResult extends Component {
  constructor(props) {
    super(props);
    let {result} = this.props;
    this.state = {image: null};
    this.imageAPI = new ImageAPI();
    // this.imageAPI.embedMedia(result.field_keyvisual.attributes.drupal_internal__mid, 'contact_block').then((results) => this.setState({image: results}))
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    let {result} = this.props;
    if (!this.state.image) {
      // this.imageAPI.embedMedia(result.field_keyvisual.attributes.drupal_internal__mid, 'contact_block').then((results) => this.setState({image: results}))
    }
  }

  componentWillReceiveProps(newProps) {
    this.setState({image: null});
  }

  render() {
    let {result} = this.props;
    let venue_types = [];
    result.field_venue_type.map((venue_type) => {
      venue_types.push((<span className="label fs-3xs mb-2xs">{venue_type.attributes.name}</span>))
    });
    const capacity = result.field_capacity;

    // {result.field_venue_type[0].attributes.name}
    return (
      <div className="venues__item">
        <div className="venue">
          <div className="venue__inner">
            <Favourite nid={result.drupal_internal__nid}/>
              <a href={drupalSettings.path.baseUrl + "node/" + result.drupal_internal__nid} className="venue__image"><VenueImage mid={result.field_keyvisual.attributes.drupal_internal__mid}/></a>
              <a href={drupalSettings.path.baseUrl + "node/" + result.drupal_internal__nid} className="venue__content">
                <div className="venue__labels">
                  {venue_types}
                </div>
              <h3 className="venue__title fs-l mb-xs">{result.title}</h3>
              <div className="fs-m2">
                <span><Trans i18nKey="search_result.venue_label_capacity" capacity={capacity}>Total capacity: {{capacity}}</Trans></span>
                <div className="venue-labels">
                  {result.field_preferred_partner && <span className="venue-label venue-label--preferred"><Trans i18nKey="search_result.venue_label_preferred">Preferred partner</Trans></span>}
                  {result.field_sustainable && <span className="venue-label venue-label--sustainable"><Trans i18nKey="search_result.venue_label_sustainable">Sustainable</Trans></span>}
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default SearchResult;
